import { initUserSessionPlugin } from '@academica-box/plugins/userSession.client'

export default defineNuxtPlugin(initUserSessionPlugin)
